// Maps a merch order line item's productId (see nssc_backend/data/merchProducts.js)
// to the product artwork/title shown in the storefront, so order details can
// display the same image the buyer saw at checkout. Kept in sync manually
// with nssc-2026/src/lib/data/shopData.js.
const MERCH_CATALOG = {
	"tshirt-1": { title: "MERCH 1 - COSMIC CAT", image: "/merch/merch-front.png" },
	"tshirt-2": { title: "MERCH 2 - ORBITAL", image: "/merch/merch-front.png" },
	"oversized-1": { title: "OVERSIZED 1 - COSMIC CAT", image: "/merch/oversized-front.png" },
	"oversized-2": { title: "OVERSIZED 2 - ORBITAL", image: "/merch/oversized-front.png" },
	"hoodie-1": { title: "DESIGN 1 - ASTRAL", image: "/merch/hoodie-front.png" },
	"hoodie-2": { title: "DESIGN 2 - VOIDBORN", image: "/merch/hoodie-front.png" },
	"hoodie-3": { title: "DESIGN 3 - OBLIVION", image: "/merch/hoodie-front.png" },
	"mug-1": { title: "MUG 1 - HUMANOID", image: "/merch/mug-1.png" },
	"mug-2": { title: "MUG 2 - COSMOS", image: "/merch/mug-2.png" },
	"mug-3": { title: "MUG 3 - COSMIC JAM", image: "/merch/mug-3.png" },
	"mug-4": { title: "MUG 4 - SPACED OUT", image: "/merch/mug-4.png" },
};

export function getMerchProduct(productId) {
	return MERCH_CATALOG[productId] || null;
}

export default MERCH_CATALOG;
